import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import EfIcon from '@elem/ui/ef-icon';
import EcoEmail from 'eco-design/elements/eco-email';
import EcoImg from 'eco-design/base/eco-img';
import { getSubscribeParams } from './config';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { subscribeTran } from './lang';
import gtm from '@/utils/gtm';
import { useProductStore } from 'elem/compPage/stream-series-plug-in-solar-battery/ProductProvider';
import { IPageStatus } from 'elem/compPage/stream-series-plug-in-solar-battery/config/IPageStatus';

const SubscribeWinUltraA: React.FC = () => {
    const { t } = useLang('theProduct.SubscribeWinUltraA');
    const { locale } = getLocal();
    const [isShow, setIsShow] = useState(false);
    const subscribeData = getSubscribeParams(locale);
    const textObj = subscribeTran[locale] || subscribeTran['eu'];
    const [show, setShow] = useState<boolean>(true);
    const [releaseShow, setReaseShow] = useState<boolean>(false);
    const { pageStatus } = useProductStore();

    const imageMap: any = {
        eu: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744961231776/pc-subscribe-bg-eu-1.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744961231776/pc-subscribe-bg-eu-1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744961231776/pc-subscribe-bg-eu-1.png',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745893067681/pc-lottery-de-1.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745893067681/pc-lottery-de-1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745893067121/m-lottery-de-1.png',
        },
        uk: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744961231776/pc-subscribe-bg-eu-1.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744961231776/pc-subscribe-bg-eu-1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744961231776/pc-subscribe-bg-eu-1.png',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745893067314/pc-lottery-fr-1.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745893067314/pc-lottery-fr-1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745893068441/m-lottery-fr-1.png',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745893067866/pc-lottery-es-1.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745893067866/pc-lottery-es-1.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745893067494/m-lottery-es-1.png',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744972510687/pc-subscribe-bg-1.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1744972510687/pc-subscribe-bg-1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1744972518382/m-subscribe-bg-1.jpg',
        },
    };

    const images = imageMap[locale] || imageMap['eu'];

    const handleJump = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: 'Pay Just 10% Deposit Now & Save More!',
            button_name: 'Pre-Order Now',
        });
    };

    useEffect(() => {
        typeof window !== undefined &&
            window.addEventListener('scroll', () => {
                const el = document.getElementById('banner');
                if (!el) return;
                const offset = el.getBoundingClientRect();
                const offsetTop = offset.top;
                const offsetBottom = offset.bottom;
                // 进入可视区域
                if (offsetTop <= window.innerHeight && offsetBottom >= 0) {
                    setReaseShow(false);
                } else {
                    setReaseShow(true);
                    // do something...
                }
            });
    });

    return (
        <>
            <section
                style={!show ? { display: 'none' } : {}}
                className={`${styles.SubscribeWinUltraA} GtmModuleData-section`}
                data-section-id="SubscribeWinUltraA2"
                data-section-title={t('subscribe_win_title')}
            >
                <div className="container-inner">
                    <div className="content-area">
                        <div className="title-box">
                            <div className="content-title">{pageStatus === IPageStatus.statusA ? t('subscribe_win_title') : t('subscribe_win_title2')}</div>
                            <p className="sub-title">{t('subscribe_win_subtitle')}</p>
                        </div>
                        <div className="subscribe-container">
                            <div className="subscribe-container-innner">
                                <div className="subscribe-area">
                                    <div className="title">
                                        {pageStatus === IPageStatus.statusA ? t('subscribe_win_subscribe_title') : t('subscribe_win_subscribe_title2')}
                                    </div>
                                    <EcoEmail
                                        tipsObj={textObj}
                                        termsHtml={textObj.termsHtml}
                                        contactListId={subscribeData.contactListId}
                                        fields={subscribeData.fields}
                                        dataLayer={{
                                            button_name: textObj.btnText,
                                            event: 'uaEvent',
                                            event_name: 'activity_submit',
                                        }}
                                        subscribeData={{
                                            sector_name: pageStatus === IPageStatus.statusA ? t('subscribe_win_title') : t('subscribe_win_title2'),
                                            entry_position: 6,
                                        }}
                                    ></EcoEmail>
                                </div>
                                {locale === 'it' && <EcoImg className="it-banner" pc={images.pc} pad={images.pad} h5={images.h5}></EcoImg>}
                                {locale !== 'it' && (
                                    <div className="subscribe-img">
                                        <EfIcon
                                            className="ribbon-1 ribbon"
                                            pc="https://websiteoss.ecoflow.com/upload/image/1744960801025/ribbon-icon1.png"
                                        ></EfIcon>
                                        <EfIcon
                                            className="ribbon-2 ribbon"
                                            pc="https://websiteoss.ecoflow.com/upload/image/1744960761610/ribbon-icon2.png"
                                        ></EfIcon>
                                        <EfIcon
                                            className="ribbon-3 ribbon"
                                            pc="https://websiteoss.ecoflow.com/upload/image/1744960813459/ribbon-icon3.png"
                                        ></EfIcon>
                                        <EcoImg pc={images.pc} pad={images.pad} h5={images.h5}></EcoImg>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {releaseShow && (
                    <div className="subscribe-icon">
                        <span onClick={() => setShow(false)} className="close-icon">
                            <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1744167030143/close.png"></EfIcon>
                        </span>
                        <a href="#Products" onClick={handleJump}>
                            <div className="content">
                                <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1743671126701/pc-subscribe-icon.png" className="sub-icon"></EfIcon>
                                <div className="pre-order">
                                    {/* <span className="win-free">Win a Free STREAM Ultra</span> */}
                                    <span className="sign-up">{t('subscribe_win_pre_order_now')}</span>
                                </div>
                            </div>
                        </a>
                    </div>
                )}
            </section>
        </>
    );
};

export default SubscribeWinUltraA;
